var exports = {
  "q": "fileRendererViewport__zCA2a_",
  "A": "fileRendererIframe__CuRWLZ",
};

module.exports = exports;
